export interface ICurrency {
	id: number;
	isForbidden: boolean;
	name: string;
	symbol: string;
	code: string;
	createdAt: string;
	updatedAt: string;
}

export interface ICoinCouple {
	id: number;
	planId: number;
	sourceCurrency: ICurrency;
	sourceCurrencyId: number;
	targetCurrency: ICurrency;
	targetCurrencyId: number;
	isActive: boolean;
	createdAt: string;
	updatedAt: string;
}

export enum planInputType {
	CODE = 'code',
	NUMBER = 'number',
}

export enum businessPlansNames {
	DEFAULT = 'Default',
	FREE = 'Free',
	BASIC = 'Basic',
	PRO = 'Pro',
}
